/**
 * Restore the persisted workspace folder on app load.
 * If the user previously picked a folder, its handle is reloaded from
 * IndexedDB; re-granting file permission needs one click after a reload
 * (surfaced in the Files panel).
 */
import { useEffect } from "react";
import { useWorkspaceStore } from "../store/workspaceStore";

export function useWorkspaceInit() {
  useEffect(() => {
    void useWorkspaceStore.getState().restore();
  }, []);
}
